import React from 'react';
import { Select, MenuItem, Box, Typography } from '@mui/material';
import { DateRange } from '@mui/icons-material';
import { useFiscalYear } from '../contexts/FiscalYearContext';
import { toPersianDigits } from '../utils/numberUtils';

// سوییچر سال مالی در هدر — انتخاب هر کاربر به‌صورت جداگانه روی سرور ذخیره می‌شود
const FiscalYearSwitcher: React.FC = () => {
  const { fiscalYears, currentFiscalYear, setCurrentFiscalYear } = useFiscalYear();

  if (fiscalYears.length === 0) return null;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mx: 1 }}>
      <DateRange sx={{ fontSize: 20, color: 'rgba(255,255,255,0.9)' }} />
      <Select
        size="small"
        variant="standard"
        disableUnderline
        value={currentFiscalYear?.id ?? ''}
        onChange={(e) => setCurrentFiscalYear(Number(e.target.value))}
        sx={{
          color: '#fff',
          fontSize: '0.85rem',
          fontWeight: 600,
          bgcolor: 'rgba(255,255,255,0.15)',
          borderRadius: 1,
          px: 1,
          py: 0.25,
          '& .MuiSelect-icon': { color: 'rgba(255,255,255,0.9)' },
          '& .MuiSelect-select': { py: 0.25, pr: '8px !important' },
        }}
        renderValue={(value) => {
          const fy = fiscalYears.find(y => y.id === value);
          return fy ? `سال مالی ${toPersianDigits(fy.name)}` : 'سال مالی';
        }}
      >
        {fiscalYears.map((fy) => (
          <MenuItem key={fy.id} value={fy.id}>
            <Typography variant="body2">
              {toPersianDigits(fy.name)}
              {fy.isClosed ? ' (بسته)' : ''}
              {fy.isCurrent ? ' — جاری' : ''}
            </Typography>
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};

export default FiscalYearSwitcher;
